//export const domain = "http://localhost:4080/api"
export const domain = "https://oxyfitclub.com/api"
export const domainFixer = ""